import React from 'react';

export * from './Header';
export * from './Content';
export * from './Footer';

export const Card = ({ style, ...props }) => {
    return <div style={{ ...styles.card, ...style }} {...props}></div>;
};

const styles = {
    card: {
        padding: '10px',
        backgroundColor: 'var(--mui-palette-common-white)',
        color: 'var(--mui-palette-secondary-boxShadow2)',
        WebkitTransition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        borderRadius: '4px',
        // border: '1px solid var(--mui-palette-secondary-boxShadow1)',
        overflow: 'hidden',
    },
};
